var AttachmentMenuEntrySource;
(function (AttachmentMenuEntrySource) {
    AttachmentMenuEntrySource["CommandingBar"] = "CommandingBar";
    AttachmentMenuEntrySource["ToolBar"] = "ToolBar";
})(AttachmentMenuEntrySource || (AttachmentMenuEntrySource = {}));
export default AttachmentMenuEntrySource;
//# sourceMappingURL=AttachmentMenuEntrySource.js.map